module.exports = __webpack_public_path__ + "static/assets/0622011940025903017586d0600cc978.png";